import { submit, getFastQuotation } from './service';

export default {
  namespace: 'application',
  state: {
    fastQuote: {},
    externalId: null,
    plan: {},
  },
  reducers: {
    setData(state: ApplicationState, { payload }: PayloadType) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *submit({ payload }: PayloadType, { put, call }: any): any {
      const { successCallback, ...rest } = payload;
      const res = yield call(submit, rest);
      if (res.error) return;
      successCallback?.(res);
    },
    *getFastQuotation({ payload }: PayloadType, { call, put }: any): any {
      const res: any = yield call(getFastQuotation, payload);
      const quote = res.quote;
      yield put({
        type: 'setData',
        payload: {
          fastQuote: quote?.fast_quote,
          externalId: quote?.external_id,
          plan: quote?.plan,
        },
      });
    },
  },
};
